import { Head } from "vite-react-ssg";
import { SITE_ORIGIN, THEME_COLOR, type RouteMeta as RouteMetaContent } from "@/content";

export const RouteMeta = ({ meta }: { meta: RouteMetaContent }) => {
  const canonical = `${SITE_ORIGIN}${meta.path}`;
  const image = `${SITE_ORIGIN}${meta.ogImage}`;

  return (
    <Head>
      <title>{meta.title}</title>
      <meta name="description" content={meta.description} />
      <meta name="theme-color" content={THEME_COLOR} />
      <link rel="canonical" href={canonical} />
      <meta property="og:type" content="website" />
      <meta property="og:url" content={canonical} />
      <meta property="og:title" content={meta.ogTitle} />
      <meta property="og:description" content={meta.ogDescription} />
      <meta property="og:image" content={image} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={meta.ogTitle} />
      <meta name="twitter:description" content={meta.ogDescription} />
      <meta name="twitter:image" content={image} />
    </Head>
  );
};
